import React from 'react';
import { ScrollView } from 'react-native';
import QuoteCard from '../components/QuoteCard';
import { styles } from '../screens/QuoteScreen.styles';
import { Quote } from '../slice/initialState';
import { formatCurrency } from '../helpers/quotesHelper';
import { formatDate, toDate } from 'src/helpers/dateHelper';
import { getCarrierLogo } from 'src/features/quotes/helpers/carrierLogoMapping';

interface QuoteListProps {
  quotes: Quote[];
  selectedQuote: string | null;
  onSelectQuote: (id: string) => void;
}

const QuoteList: React.FC<QuoteListProps> = ({ quotes, selectedQuote, onSelectQuote }) => {
  const safeFormatDate = (date: string | null | undefined, format: string): string => {
    const parsedDate = toDate(date ?? null);
    return parsedDate ? formatDate(parsedDate, format) : 'N/A';
  };

  return (
    <ScrollView contentContainerStyle={styles.scrollContainer} showsVerticalScrollIndicator={false}>
      {/* Real-time quotes */}
      {quotes.map((quote) => (
        <QuoteCard
          key={quote.quoteNumber}
          id={String(quote.id as number)}
          price={formatCurrency(
            quote.totalPremiumWEndorsements?.amount,
            quote.totalPremiumWEndorsements?.currency,
          )}
          details={{
            quoteNumber: quote.quoteNumber,
            effectiveDate: safeFormatDate(quote.effectiveDate, 'MM/DD/YYYY'),
            expirationDate: safeFormatDate(quote.expirationDate, 'MM/DD/YYYY'),
            basePremium: formatCurrency(quote.bindingPremium.amount, quote.bindingPremium.currency),
            taxes: formatCurrency(quote.taxes?.amount, quote.taxes?.currency),
            fees: formatCurrency(quote.fees?.amount, quote.fees?.currency),
            logo: getCarrierLogo(quote.issuingCarrierId || quote.billingCarrierId),
            quotePdf: quote.quotePdf,
          }}
          isSelected={selectedQuote === String(quote.id as number)}
          onSelect={onSelectQuote}
          coverage={quote.linesOfBusiness.join('/')}
        />
      ))}
    </ScrollView>
  );
};

export default QuoteList;
